const Colors = {
  white: "#FFFFFF",
  black: "#000000",
  mediumBlack: "#616161",

  // gray
  darkGray: "#8F92A1",
  mediumGray: "rgba(143, 146, 161, 0.2)",
  lightGray: "#C4C4C4",
  lightestGray: "#F2F2F2",

  // red
  mediumRed: "#FF0000",

  // blue
  darkBlue: "#171B5E",

  // green
  lightGreeen: "#0BAB5E",

  // New Blue Color
  midnightBlue: "#003E99",
  mediumBlue: "#183053",

  // Submit Button hover Color
  hoverBlue: "#0054CC",
};

export default Colors;
